import Axios, {AxiosInstance} from "axios";
import UserApi from "./UserApi";
import ContactApi from "./ContactApi";
import SiteApi from "./SiteApi";
import LeadApi from "./LeadApi";
import {store} from "../navigation/ReduxProvider";
import {logOut} from "../store/action/user/user";
import Toast from "../components/helper/Toast";
import AddressApi from "./AddressApi";
import NoteApi from "./NoteApi";
import NotificationApi from "./NotificationApi";
import HelpApi from "./HelpApi";
import AcquisitionChannelApi from "./AcquisitionChannelApi";
import LeadTypeApi from "./LeadTypeApi";
import AppointmentApi from "./AppointmentApi";
import GoogleApi from "./GoogleApi";
import UserLocationApi from "./UserLocationApi";
import SettingsApi from "./SettingsApi";
import ValidationApi from "./ValidationApi";
import QuoteApi from "./QuoteApi";
import AttachmentApi from "./AttachmentApi";
import BrandApi from "./BrandApi";
import TagApi from "./TagApi";
import AssetApi from "./AssetApi";
import OrganizationApi from "./OrganizationApi";
import TaskApi from "./TaskApi";
import SmsApi from "./SmsApi";
import TwilioApi from "./TwilioApi";
import JobApi from "./JobApi";
import JobTypeApi from "./JobTypeApi";
import UtilityApi from "./UtilityApi";
import CategoryApi from "./CategoryApi";
import JobStatusApi from "./JobStatusApi";
import PostcodeApi from "./PostcodeApi";
import LeadStatusApi from "./LeadStatusApi";
import ActivityTemplateApi from "./ActivityTemplateApi";
import AssetCategoryApi from "./AssetCategoryApi";
import PartnerBrandApi from "./PartnerBrandApi";
import WorkspaceApi from "./WorkspaceApi";
import MerchantApi from "./MerchantApi";
import AccountApi from "./AccountApi";
import GeneralLedgerApi from "./GeneralLedgerApi";
import BillApi from "./BillApi";
import InvoiceApi from "./InvoiceApi";
import InvoicePaymentApi from "./InvoicePaymentApi";
import JournalApi from "./JournalApi";
import TransactionApi from "./TransactionApi";
import RevolutAuthApi from "./RevolutAuthApi";
import MigrationApi from "./MigrationApi";
import XeroAuthApi from "./XeroAuthApi";
import BillPaymentApi from "./BillPaymentApi";
import CustomFieldApi from "./CustomFieldApi";
import SidebarOrderApi from "./SidebarOrderApi";
import JobBillOfMaterialsApi from "./JobBillOfMaterialsApi";
import FinanceProductApi from "./FinanceProductApi";
import CodatErrorsApi from "./CodatErrorsApi";
import OperationErrorsApi from "./OperationErrorsApi";
import MerchantPartsApi from "./MerchantPartsApi";
import MasterCatalogApi from "./MasterCatalogApi";
import HistoricalJobImportApi from "./HistoricalJobImportApi";
import EvChargingApi from "./EvChargingApi";

export namespace api {
	/**
	 * Class with one instance of api.
	 */
	class ApiInstance {
		/**
		 * Instance of the api.
		 */
		api: Api;

		constructor() {
			this.api = new Api();
		}

		create() {
			this.api = new Api();
		}

		get userApi(): UserApi {
			return this.api.userApi;
		}

		get contactApi(): ContactApi {
			return this.api.contactApi;
		}

		get siteApi(): SiteApi {
			return this.api.siteApi;
		}

		get leadApi(): LeadApi {
			return this.api.leadApi;
		}

		get addressApi(): AddressApi {
			return this.api.addressApi;
		}

		get noteApi(): NoteApi {
			return this.api.noteApi;
		}

		get notificationApi(): NotificationApi {
			return this.api.notificationApi;
		}

		get helpApi(): HelpApi {
			return this.api.helpApi;
		}

		get acquisitionChannelApi(): AcquisitionChannelApi {
			return this.api.acquisitionChannelApi;
		}

		get leadTypeApi(): LeadTypeApi {
			return this.api.leadTypeApi;
		}

		get appointmentApi(): AppointmentApi {
			return this.api.appointmentApi;
		}

		get googleApi(): GoogleApi {
			return this.api.googleApi;
		}

		get userLocationApi(): UserLocationApi {
			return this.api.userLocationApi;
		}

		get settingsApi(): SettingsApi {
			return this.api.settingsApi;
		}

		get validationApi(): ValidationApi {
			return this.api.validationApi;
		}

		get quoteApi(): QuoteApi {
			return this.api.quoteApi;
		}

		get attachmentApi(): AttachmentApi {
			return this.api.attachmentApi;
		}

		get brandApi(): BrandApi {
			return this.api.brandApi;
		}

		get tagApi(): TagApi {
			return this.api.tagApi;
		}

		get organizationApi(): OrganizationApi {
			return this.api.organizationApi;
		}

		get assetApi(): AssetApi {
			return this.api.assetApi
		}

		get postcodeApi(): PostcodeApi {
			return this.api.postcodeApi
		}

		get taskApi(): TaskApi {
			return this.api.taskApi
		}

		get smsApi(): SmsApi {
			return this.api.smsApi;
		}

		get twilioApi(): TwilioApi {
			return this.api.twilioApi;
		}

		get jobApi(): JobApi {
			return this.api.jobApi;
		}

		get jobBillOfMaterialsApi(): JobBillOfMaterialsApi {
			return this.api.jobBillOfMaterialsApi;
		}

		get jobTypeApi(): JobTypeApi {
			return this.api.jobTypeApi;
		}

		get utilityApi(): UtilityApi {
			return this.api.utilityApi;
		}

		get categoryApi(): CategoryApi {
			return this.api.categoryApi;
		}

		get jobStatusApi(): JobStatusApi {
			return this.api.jobStatusApi;
		}

		get leadStatusApi(): LeadStatusApi {
			return this.api.leadStatusApi;
		}

		get activityTemplateApi(): ActivityTemplateApi {
			return this.api.activityTemplateApi;
		}

		get assetCategoryApi(): AssetCategoryApi {
			return this.api.assetCategoryApi;
		}

		get partnerBrandApi(): PartnerBrandApi {
			return this.api.partnerBrandApi;
		}

		get workspaceApi(): WorkspaceApi {
			return this.api.workspaceApi
		}

		get merchantApi(): MerchantApi {
			return this.api.merchantApi
		}

		get accountApi(): AccountApi {
			return this.api.accountApi;
		}

		get generalLedgerApi(): GeneralLedgerApi {
			return this.api.generalLedgerApi;
		}

		get billApi(): BillApi {
			return this.api.billApi;
		}

		get invoiceApi(): InvoiceApi {
			return this.api.invoiceApi;
		}

		get invoicePaymentApi(): InvoicePaymentApi {
			return this.api.invoicePaymentApi;
		}

		get journalApi(): JournalApi {
			return this.api.journalApi;
		}

		get transactionApi(): TransactionApi {
			return this.api.transactionApi;
		}

		get revolutAuthApi(): RevolutAuthApi {
			return this.api.revolutAuthApi;
		}

		get migrationApi(): MigrationApi {
			return this.api.migrationApi;
		}

		get xeroAuthApi(): XeroAuthApi {
			return this.api.xeroAuthApi;
		}

		get billPaymentApi(): BillPaymentApi {
			return this.api.billPaymentApi;
		}

		get customFieldApi(): CustomFieldApi {
			return this.api.customFieldApi;
		}

		get sidebarOrderApi(): SidebarOrderApi {
			return this.api.sidebarOrderApi;
		}

		get financeProductApi(): FinanceProductApi {
			return this.api.financeProductApi;
		}

		get codatErrorsApi(): CodatErrorsApi {
			return this.api.codatErrorsApi;
		}

		get operationErrorsApi(): OperationErrorsApi {
			return this.api.operationErrorsApi;
		}

		get partsApi(): MerchantPartsApi {
			return this.api.merchantPartsApi;
		}

		get masterCatalogApi(): MasterCatalogApi {
			return this.api.masterCatalogApi;
		}

		get historicalJobImportApi(): HistoricalJobImportApi {
			return this.api.historicalJobImportApi;
		}

		get evChargingApi(): EvChargingApi {
			return this.api.evChargingApi;
		}
	}

	/**
	 * Class containing axios instance and all APIs.
	 */
	class Api {
		private readonly axiosInstance: AxiosInstance;
		public readonly userApi: UserApi;
		public readonly contactApi: ContactApi;
		public readonly siteApi: SiteApi;
		public readonly leadApi: LeadApi;
		public readonly addressApi: AddressApi;
		public readonly noteApi: NoteApi;
		public readonly notificationApi: NotificationApi;
		public readonly helpApi: HelpApi;
		public readonly acquisitionChannelApi: AcquisitionChannelApi;
		public readonly leadTypeApi: LeadTypeApi;
		public readonly appointmentApi: AppointmentApi;
		public readonly googleApi: GoogleApi;
		public readonly userLocationApi: UserLocationApi;
		public readonly settingsApi: SettingsApi;
		public readonly validationApi: ValidationApi;
		public readonly quoteApi: QuoteApi;
		public readonly attachmentApi: AttachmentApi;
		public readonly brandApi: BrandApi;
		public readonly tagApi: TagApi;
		public readonly assetApi: AssetApi;
		public readonly postcodeApi: PostcodeApi;
		public readonly organizationApi: OrganizationApi;
		public readonly taskApi: TaskApi;
		public readonly smsApi: SmsApi;
		public readonly twilioApi: TwilioApi;
		public readonly jobApi: JobApi;
		public readonly jobBillOfMaterialsApi: JobBillOfMaterialsApi;
		public readonly jobTypeApi: JobTypeApi;
		public readonly utilityApi: UtilityApi;
		public readonly categoryApi: CategoryApi;
		public readonly jobStatusApi: JobStatusApi;
		public readonly leadStatusApi: LeadStatusApi;
		public readonly activityTemplateApi: ActivityTemplateApi;
		public readonly assetCategoryApi: AssetCategoryApi;
		public readonly partnerBrandApi: PartnerBrandApi;
		public readonly workspaceApi: WorkspaceApi;
		public readonly merchantApi: MerchantApi;
		public readonly accountApi: AccountApi;
		public readonly generalLedgerApi: GeneralLedgerApi;
		public readonly billApi: BillApi;
		public readonly invoiceApi: InvoiceApi;
		public readonly invoicePaymentApi: InvoicePaymentApi;
		public readonly journalApi: JournalApi;
		public readonly transactionApi: TransactionApi;
		public readonly revolutAuthApi: RevolutAuthApi;
		public readonly migrationApi: MigrationApi;
		public readonly xeroAuthApi: XeroAuthApi;
		public readonly billPaymentApi: BillPaymentApi;
		public readonly customFieldApi: CustomFieldApi;
		public readonly sidebarOrderApi: SidebarOrderApi;
		public readonly financeProductApi: FinanceProductApi;
		public readonly codatErrorsApi: CodatErrorsApi;
		public readonly operationErrorsApi: OperationErrorsApi;
		public readonly merchantPartsApi: MerchantPartsApi;
		public readonly masterCatalogApi: MasterCatalogApi;
		public readonly historicalJobImportApi: HistoricalJobImportApi;
		public readonly evChargingApi: EvChargingApi;

		constructor() {
			this.axiosInstance = this.createInstance();
			this.userApi = new UserApi(this.axiosInstance);
			this.contactApi = new ContactApi(this.axiosInstance);
			this.siteApi = new SiteApi(this.axiosInstance);
			this.leadApi = new LeadApi(this.axiosInstance);
			this.addressApi = new AddressApi(this.axiosInstance);
			this.noteApi = new NoteApi(this.axiosInstance);
			this.notificationApi = new NotificationApi(this.axiosInstance);
			this.helpApi = new HelpApi(this.axiosInstance);
			this.acquisitionChannelApi = new AcquisitionChannelApi(this.axiosInstance);
			this.leadTypeApi = new LeadTypeApi(this.axiosInstance);
			this.appointmentApi = new AppointmentApi(this.axiosInstance);
			this.googleApi = new GoogleApi(this.axiosInstance);
			this.userLocationApi = new UserLocationApi(this.axiosInstance);
			this.settingsApi = new SettingsApi(this.axiosInstance);
			this.validationApi = new ValidationApi(this.axiosInstance);
			this.quoteApi = new QuoteApi(this.axiosInstance);
			this.attachmentApi = new AttachmentApi(this.axiosInstance);
			this.brandApi = new BrandApi(this.axiosInstance);
			this.tagApi = new TagApi(this.axiosInstance);
			this.organizationApi = new OrganizationApi(this.axiosInstance);
			this.assetApi = new AssetApi(this.axiosInstance);
			this.postcodeApi = new PostcodeApi(this.axiosInstance);
			this.taskApi = new TaskApi(this.axiosInstance);
			this.smsApi = new SmsApi(this.axiosInstance);
			this.twilioApi = new TwilioApi(this.axiosInstance);
			this.jobApi = new JobApi(this.axiosInstance);
			this.jobBillOfMaterialsApi = new JobBillOfMaterialsApi(this.axiosInstance);
			this.jobTypeApi = new JobTypeApi(this.axiosInstance);
			this.utilityApi = new UtilityApi(this.axiosInstance);
			this.categoryApi = new CategoryApi(this.axiosInstance);
			this.jobStatusApi = new JobStatusApi(this.axiosInstance);
			this.leadStatusApi = new LeadStatusApi(this.axiosInstance);
			this.activityTemplateApi = new ActivityTemplateApi(this.axiosInstance);
			this.assetCategoryApi = new AssetCategoryApi(this.axiosInstance);
			this.partnerBrandApi = new PartnerBrandApi(this.axiosInstance);
			this.workspaceApi = new WorkspaceApi(this.axiosInstance);
			this.merchantApi = new MerchantApi(this.axiosInstance);
			this.accountApi = new AccountApi(this.axiosInstance);
			this.generalLedgerApi = new GeneralLedgerApi(this.axiosInstance);
			this.billApi = new BillApi(this.axiosInstance);
			this.invoiceApi = new InvoiceApi(this.axiosInstance);
			this.invoicePaymentApi = new InvoicePaymentApi(this.axiosInstance);
			this.journalApi = new JournalApi(this.axiosInstance);
			this.transactionApi = new TransactionApi(this.axiosInstance);
			this.revolutAuthApi = new RevolutAuthApi(this.axiosInstance);
			this.migrationApi = new MigrationApi(this.axiosInstance);
			this.xeroAuthApi = new XeroAuthApi(this.axiosInstance);
			this.billPaymentApi = new BillPaymentApi(this.axiosInstance);
			this.customFieldApi = new CustomFieldApi(this.axiosInstance);
			this.sidebarOrderApi = new SidebarOrderApi(this.axiosInstance);
			this.financeProductApi = new FinanceProductApi(this.axiosInstance);
			this.codatErrorsApi = new CodatErrorsApi(this.axiosInstance);
			this.operationErrorsApi = new OperationErrorsApi(this.axiosInstance);
			this.merchantPartsApi = new MerchantPartsApi(this.axiosInstance);
			this.masterCatalogApi = new MasterCatalogApi(this.axiosInstance);
			this.historicalJobImportApi = new HistoricalJobImportApi(this.axiosInstance);
			this.evChargingApi = new EvChargingApi(this.axiosInstance);
		}

		/**
		 * Create api instance.
		 */
		private createInstance(): AxiosInstance {
			const headers: { [key: string]: string } = {};
			const axios = Axios.create({
				timeout: 30000,
				headers: headers
			});

			axios.interceptors.response.use(data => data, data => {
				if (data.code == "ECONNABORTED") {
					return Promise.reject(data);
				}
				const isLoggedIn = store.getState().user.user.isDefined;
				if (data.response && data.response.status == 401 && isLoggedIn) {
					store.dispatch(logOut());
					Toast.error("For security reasons, you have been automatically signed out. Please sign in again.");
				}
				return Promise.reject(data);
			});
			return axios;
		};
	}

	/**
	 * Instance of api.
	 */
	export const instance: ApiInstance = new ApiInstance();
}
